import { TaskType } from '@common';

export interface IProgramTaskMetadata {
  memberCount?: number;
  workletSpecUri?: string;
  taskId?: string;
}

export interface IProgramTask {
  taskName: TaskType;
  isCompleted: boolean;
  metadata?: IProgramTaskMetadata;
}

export interface IProgramTasksResponse {
  tasks: IProgramTask[];
}
